import axios from 'axios'
import Pusher from 'pusher-js'
import { ensureFreshToken } from './axios'

Pusher.logToConsole = true

// Jeda percobaan ulang auth channel saat gagal jaringan / server (bukan 401/403)
const AUTH_RETRY_DELAYS_MS = [2000, 4000, 8000, 15000, 30000, 30000]

const wait = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

/**
 * Auth private channel lewat axios global (baseURL per perusahaan + interceptor di main.jsx),
 * dipanggil setiap subscribe (termasuk saat reconnect). Token di-refresh dulu bila sudah/hampir expired dan 401 tetap lewat alur refresh interceptor,
 * jadi tab yang terbuka lama (mis. layar pelanggan) tidak putus karena access token expired.
 */
const authorizeChannel = async ({ socketId, channelName }, callback, attempt = 0) => {
  try {
    await ensureFreshToken()
    const { data } = await axios.post('/broadcasting/auth', {
      socket_id: socketId,
      channel_name: channelName,
    })
    callback(null, data)
  } catch (error) {
    const status = error?.status ?? error?.response?.status
    const isRetryable = !status || status >= 500
    if (!isRetryable || attempt >= AUTH_RETRY_DELAYS_MS.length) {
      callback(error, null)
      return
    }
    await wait(AUTH_RETRY_DELAYS_MS[attempt])
    authorizeChannel({ socketId, channelName }, callback, attempt + 1)
  }
}

export const createPusherInstance = () => {
  const pusher = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
    forceTLS: true,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    channelAuthorization: {
      customHandler: authorizeChannel,
    },
  })
  return pusher
}
